import PlatformBreakoutFilter from './PlatformBreakoutFilter';

export default PlatformBreakoutFilter;
